// extracted by css-extract-rspack-plugin
var _1 = "dNrkmlVLRAjnMBdN";
var _2 = "dNrkmlVLRAjnMBdN";
var _3 = "wkwUN7y2KZw_W2cy";
var _4 = "wkwUN7y2KZw_W2cy";
export { _1 as "fixed-video", _2 as "fixedVideo", _3 as "sticky-video", _4 as "stickyVideo" }
